import { render, staticRenderFns } from "./HeaderNav.vue?vue&type=template&id=2780575c&"
import script from "./HeaderNav.vue?vue&type=script&lang=js&"
export * from "./HeaderNav.vue?vue&type=script&lang=js&"
import style0 from "./HeaderNav.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports